export const getFormatedDate = (date: string) => {
  const dateObject = new Date(date)
  const dayOfMonth = dateObject.getUTCDate()
  const dayOfWeekNumber = dateObject.getUTCDay()
  const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  const monthIndex = dateObject.getUTCMonth()
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]
  const year = dateObject.getUTCFullYear()

  return {
    weekday: daysOfWeek[dayOfWeekNumber],
    day: dayOfMonth,
    month: monthNames[monthIndex],
    year: year,
  }
}

/**
 * Will format a js Date into MM/DD or MM/DD/YY
 * @param date
 * @param shouldDisplayYear
 * @returns
 */
export const formatDate = (date: Date, shouldDisplayYear: boolean) => {
  return Intl.DateTimeFormat(undefined, {
    month: '2-digit',
    day: '2-digit',
    ...(shouldDisplayYear ? { year: '2-digit' } : {}),
  }).format(date)
}

/**
 * Will return how many days are left until a given Date
 * @param futureDate
 * @returns
 */
export const getDaysUntil = (futureDate: Date) => {
  const today = new Date()

  const daysLeft = Math.round(
    (futureDate.getTime() - today.getTime()) / (1000 * 3600 * 24),
  )
  return daysLeft
}
